<!-- 会员升级礼活动规则设置 -->
<template>
  <div>
    <jd-title label='活动规则设置' type="bold"></jd-title>
    <el-form-item label="可领奖等级:" required>
      <el-checkbox-group v-model="formData.memberLevels" @change="checkCustomerchange" :disabled="isDisabled">
        <el-checkbox label="-1" name="memberLevels">全部</el-checkbox>
        <el-checkbox v-for="(item, index) in levelList" :key="index" :label="index + 1 + ''" name="memberLevels">{{
          item.name }}</el-checkbox>
      </el-checkbox-group>
    </el-form-item>

    <el-form-item label="等级规则设置:" required>
      <div class="setting-level">
        <div :class="[
          'setting-level-item',
          { 'setting-level-item__active': levelIndex == index },
        ]" v-for="(item, index) in getChooseCustomer" :key="item.value" @click="levelClick(index)">
          <span>{{ item.name }}</span>
        </div>
      </div>

      <template v-for="(item, it) in prizeSettingListLevel">
        <div class="rule-set-box" v-if="levelIndex == it" :key="it">
          <el-form-item label="等级条件:" required label-width="125px">
            <el-input v-model="item.memberLevelCondition" maxlength="20" show-word-limit style="width: 330px"
              :disabled="isDisabled2" placeholder="请输入"></el-input>
            <jd-tip style="margin-top: 12px">
              <div>
                输入达到该等级的等级条件，如：消费200元可达该等级
              </div>
              <div>
                仅用于C端提示使用，无实际校验效果，建议与实际会员升级体系保持一致。
              </div>
            </jd-tip>
          </el-form-item>

          <el-form-item label="等级奖品:" required label-width="125px">
            <div>
              -开启【高等级可领】，是指配置了2级会员奖品，除了达到2级的会员可领取外，3级及以上的会员也可领取；
            </div>
            <div>
              -开启【升级可领取】，是指用户在活动时间内先后进入活动发生升级到当前等级才可领取对应奖品；
            </div>
            <div>
              -开启【降级不可领】，是指用户在活动时间内先后进入活动退级到当前等级不可领对应奖品；
            </div>
            <div>
              <el-table :data="item.settingList" style="border: 1px solid #eeeeee; width: 100%;"
                :header-cell-style="{
                  background: '#F0F2F7',
                  'text-align': 'left',
                }">
                <el-table-column label="奖品类型" align="center">
                  <template slot-scope="scope">
                    {{ getPrizeTypeName(scope.row.prizeType) }}
                    <!-- <span v-if="scope.row.prizeType == 1">优惠券</span>
                    <span v-if="scope.row.prizeType == 2">京豆</span>
                    <span v-if="scope.row.prizeType == 3">实物</span>
                    <span v-if="scope.row.prizeType == 4">店铺积分</span>
                    <span v-if="scope.row.prizeType == 5">京东E卡</span>
                    <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                    <span v-if="scope.row.prizeType == 7">京东Plus会员</span>
                    <span v-if="scope.row.prizeType == 8">现金红包</span>
                    <span v-if="scope.row.prizeType == 9">礼品卡</span>
                    <span v-if="scope.row.prizeType == 12">{{venderType? '令牌' : '专享价'}}</span>
                    <span v-if="scope.row.prizeType == 13">令牌</span> -->
                  </template>
                </el-table-column>
                <el-table-column label="值" width="100" prop="price" align="center"></el-table-column>
                <el-table-column label="奖品名称（12字内）" width="270">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.title" maxlength="12"    
                      show-word-limit style="width: 230px" placeholder="请输入"></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="奖品数量" width="150">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.totalAmount" @input="
                      scope.row.totalAmount = getNumberData(
                        1,
                        $event,
                        0,
                        1,
                        999999
                      )
                      " class="inputcount" style="width: 120px" placeholder="请输入"
                      :disabled="!isEditCount(scope.row)"></el-input>
                  </template>
                </el-table-column>
                <!-- 进行中的活动显示剩余库存 -->
                <el-table-column v-if="activityData.isStart" label="剩余库存" width="130">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.remanentAmount" class="inputcount" style="width: 100px"
                      placeholder="请输入" :disabled="true"></el-input>
                  </template>
                </el-table-column>
                <el-table-column width="160">
                  <template slot="header">
                    <div>图片(208px*208px)</div>
                  </template>
                  <template slot-scope="scope">
                    <img :src="scope.row.logo" style="width: 50px; height: 50px" disabled />
                  </template>
                </el-table-column>
                <el-table-column label="领取设置" width="180">
                  <template slot-scope="scope">
                    <div>
                      <span class="mr-r-6">高等级可领</span>
                      <el-switch v-model="scope.row.highLevelGetFlag" :disabled="backgroundOpacity"></el-switch>
                    </div>
                    <div>
                      <span class="mr-r-6">升级可领取</span>
                      <el-switch v-model="scope.row.upgradeGetFlag" :disabled="backgroundOpacity"></el-switch>
                    </div>
                    <div>
                      <span class="mr-r-6">降级不可领</span>
                      <el-switch v-model="scope.row.downgradeGetFlag" :disabled="backgroundOpacity"></el-switch>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="每日发放限额" width="120">
                  <template slot-scope="scope">
                    <dailyLimitConfig
                      :row="scope.row"
                      :backgroundOpacity="backgroundOpacity"
                      :limitBtnDisabled="backgroundOpacity"
                    ></dailyLimitConfig>
                  </template>
                </el-table-column>
                <el-table-column label="操作" min-width="135" fixed="right">
                  <template slot-scope="scope">
                    <jd-button type="blueText" v-if="isShowSelect(scope.row)"
                      @click="onSelectPrize(scope.row, scope.$index)">选择奖品</jd-button>
                    <jd-button v-if="item.settingList.length > 1" type="blueText" :disabled="!isShowDelete(scope.row)"
                      @click="onDeleteSetting(scope.$index, item)">删除</jd-button>
                    <jd-button v-if="scope.$index > 0" type="blueText" :disabled="isDisabled"
                      @click="onMoveUpGoods(scope.$index, item)">上移</jd-button>
                    <jd-button v-if="
                      scope.$index < item.settingList.length - 1
                    " type="blueText" :disabled="isDisabled"
                      @click="onMoveDownGoods(scope.$index, item)">下移</jd-button>
                    <el-upload v-if="!isDisabled
                    " class="upload" action="/jd-hd-web/image/upload" :show-file-list="false"
                      :before-upload="beforeUpload" :on-success="(file) => {
                        return handleUpload(file, scope);
                      }
                        ">
                      <div class="s" style="margin-right: 10px">
                        上传图片
                      </div>
                    </el-upload>
                    <jd-button type="blueText" v-if="isShowAddCount(scope.row)"
                      @click="addCount(scope.$index, scope.row)">增加库存</jd-button>
                  </template>
                </el-table-column>
              </el-table>
              <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
              <jd-button type="blue" v-if="
                levelIndex == it &&
                item.settingList.length < 5 &&
                !backgroundOpacity
              " @click="onAddSetting(item)" style="margin-top: 12px">增加奖品{{ item.settingList.length
              }}/5</jd-button>
            </div>
          </el-form-item>
          <el-form-item label="点击去升级:" label-width="125px">
            <div><el-input v-model="item.jumpInfo" style="width: 250px" placeholder="请输入链接"
                :disabled="backgroundOpacity"></el-input>
              <span style="color: #999999; margin-left: 20px; font-size: 13px;">当用户查看高等级奖品时，将引导用户升级，可配置升级跳转路径</span>
            </div>
            <div class="linkTip">链接需包含 .isvjcloud.com , .isvbjd.com或 .jd.com ;只能以 http:// ， https:// 开头</div>
          </el-form-item>


          <el-form-item label="等级权益:" label-width="125px">
            <el-table :data="item.gradeEquityList" style="border: 1px solid #eeeeee; width: 1100px" :header-cell-style="{
              background: '#F0F2F7',
              'text-align': 'left',
            }">
              <el-table-column label="权益图标" width="150">
                <template slot-scope="scope">
                  <img :src="scope.row.benefitEnableIconUrl" style="width: 50px; height: 50px" disabled />
                </template>
              </el-table-column>
              <el-table-column label="权益名称" min-width="150" prop="name">
              </el-table-column>
              <el-table-column label="跳转链接" min-width="150" prop="jumpType">
                <template slot-scope="scope">
                  <span v-if="scope.row.jumpInfo">
                    {{ scope.row.jumpInfo }}
                  </span>
                  <span v-else>-</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="180">
                <template slot-scope="scope">
                  <jd-button type="blueText" :disabled="backgroundOpacity"
                    @click="onEquityDel(scope.$index, item)">移除</jd-button>
                  <jd-button v-if="scope.$index > 0" type="blueText" :disabled="backgroundOpacity"
                    @click="onMoveUpEquity(scope.$index, item)">上移</jd-button>
                  <jd-button
                    v-if="Array.isArray(item.gradeEquityList) && scope.$index < item.gradeEquityList.length - 1"
                    type="blueText" :disabled="backgroundOpacity"
                    @click="onMoveDownEquity(scope.$index, item)">下移</jd-button>
                </template>
              </el-table-column>
            </el-table>
            <jd-button v-if="!isDisabled2" type="blue" @click="onAddEquity(item)" style="margin-top: 12px">添加权益{{
              item.gradeEquityList ? item.gradeEquityList.length : 0 }}/20</jd-button>
            <jd-button v-else type="blue" style=" margin-top: 12px">添加权益{{
              item.gradeEquityList ? item.gradeEquityList.length : 0 }}/20</jd-button>
          </el-form-item>
        </div>
      </template>
    </el-form-item>
    <el-form-item label="每人领奖限制:" label-width="125px">
      <span class="mr-r-6">当前活动每人限制领取</span>
      <el-input v-model="formData.limitPerPerson" @input="
        formData.limitPerPerson = getNumberData(1, $event, 0, 1, 999999)
        " class="mr-r-6" style="width: 100px" :disabled="isDisabled"></el-input>
      <span>次奖品，超出次数，即使再升级也不能领取奖品</span>
      <span style="color: #999999">（不填则默认不限，只要符合条件即可领）</span>
    </el-form-item>
  </div>
</template>

<script>
import dailyLimitConfig from "@/views/interactiveMarketing/activity/components/dailyLimitConfig.vue";
export default {
  name: 'ActivityRuleSettings',
  components: {
    dailyLimitConfig,
  },
  props: {
    // 表单数据
    value: {
      type: Object,
      required: true
    },
    // 活动数据
    activityData: {
      type: Object,
      default: () => ({
        isStart: false
      })
    },
    // 背景透明度控制（禁用状态）
    backgroundOpacity: {
      type: Boolean,
      default: false
    },
    // 会员等级列表
    levelList: {
      type: Array,
      default: () => []
    },
    // 奖品设置列表
    prizeSettingListLevel: {
      type: Array,
      default: () => []
    },
    // 当前选中的等级索引
    levelIndex: {
      type: Number,
      default: 0
    },
    isCopy: { // 是否为复制模式
      type: Boolean,
      default: false
    },
    isDraftEdit: { // 是否为编辑草稿状态
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formData: this.value
    };
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    // 获取已选择的会员等级
    getChooseCustomer() {
      if (this.formData.memberLevels.includes("-1")) {
        return this.levelList;
      } else {
        return this.levelList.filter((item) => this.formData.memberLevels.includes(item.value)
        );
      }
    },
    isDisabled() { // 活动开始和查看状态都不可修改
      return this.activityData.isStart || this.backgroundOpacity;
    },
    isDisabled2() { // 查看状态不可修改
      return this.backgroundOpacity;
    },
  },
  watch: {
    value: {
      handler(val) {
        this.formData = val;
      },
      deep: true
    },
    formData: {
      handler(val) {
        this.$emit('input', val);
      },
      deep: true
    },
  },
  methods: {
    // 数字输入处理
    // getNumberData(type, value, decimal, min, max) {
    //   // TODO:  实现数字输入处理逻辑
    //   return this.$emit('get-number-data', type, value, decimal, min, max);
    // },
    beforeUpload(file) {
      let _this = this;
      const isSize = new Promise((resolve, reject) => {
        let width = 208;
        let height = 208;
        var _URL = window.URL || window.webkitURL;
        var img = new Image();
        img.onload = function () {
          let valid = width === this.width && height === this.height;
          valid ? resolve() : reject(this);
          _this.uploadSize = valid;
        }
        img.src = _URL.createObjectURL(file);
      }).then(() => {
        return file
      }, () => {
        this.$message.info("奖品展示图片尺寸不符合要求,请重新上传");
        return Promise.reject()
      })

      // 校验尺寸和类型
      const isLt3M = file.size < 300 * 1024;
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"];
      const isType = sorts.includes(type)

      if (!isLt3M) {
        this.$message.info("奖品展示图片大小不符合要求,请重新上传");
      }
      if (!isType) {
        this.$message.info("奖品展示图片格式不符合要求,请重新上传");
      }

      return isLt3M && isType && isSize
    },
    // 上传图片
    handleUpload(file, scope) {
      console.log("--- file:---", file)
      if (file.code != 1) {
        this.$message.error(file.messaga || "上传失败");
        return;
      }

      // 更新图片URL到对应的奖品设置中
      if (this.uploadSize) {
        scope.row.prizeImg = file.data;
        this.$emit('upload-prize-iamge', file.data, scope.row);
      }
    },
    // 会员等级选择变更
    checkCustomerchange(val) {
      this.$emit('check-customer-change', val);
    },
    // 等级点击
    levelClick(index) {
      this.$emit('level-click', index);
    },
    // 选择奖品
    onSelectPrize(row, index) {
      // 给title增加响应式
      this.$set(row, "title", "")
      this.$emit('select-prize', row, index);
    },
    // 删除奖品设置
    onDeleteSetting(index, item) {
      this.$emit('delete-setting', index, item);
    },
    // 奖品上移
    onMoveUpGoods(index, item) {
      this.$emit('move-up-goods', index, item);
    },
    // 奖品下移
    onMoveDownGoods(index, item) {
      this.$emit('move-down-goods', index, item);
    },
    // 增加库存
    addCount(index, row) {
      this.$emit('add-count', index, row);
    },
    // 添加奖品设置
    onAddSetting(item) {
      this.$emit('add-setting', item);
    },
    // 显示选择活动弹窗
    onShowSelectAct() {
      this.$emit('show-select-act');
    },
    // 添加权益
    onAddEquity(item) {
      this.$emit('add-equity', item);
    },
    // 删除权益
    onEquityDel(index, item) {
      this.$emit('equity-del', index, item);
    },
    // 权益上移
    onMoveUpEquity(index, item) {
      this.$emit('move-up-equity', index, item);
    },
    // 权益下移
    onMoveDownEquity(index, item) {
      this.$emit('move-down-equity', index, item);
    },
    isShowAddCount(row) { // 是否显示增加库存
      let flag = false;
      if (row.id && !this.backgroundOpacity && this.activityData.isStart) {
        flag = true;
      }
      return flag;
    },
    isShowSelect(row) { // 是否显示选择奖品
      if (this.isCopy || this.isDraftEdit) { // 复制模式和草稿编辑可以选择奖品
        return true
      }
      // 活动未开始且不是查看模式
      if (!this.activityData.isStart && !this.backgroundOpacity) {
        return true
      }
      let flag = true;
      if (row.id || this.backgroundOpacity) {
        flag = false;
      }
      return flag;
    },
    isShowDelete(row) { // 是否可以删除奖品
      if (this.isCopy || this.isDraftEdit) { // 复制模式和草稿编辑可以删除奖品
        return true
      }
      // 活动未开始且不是查看模式
      if (!this.activityData.isStart && !this.backgroundOpacity) {
        return true
      }
      let flag = true;
      if (row.id) {
        flag = false;
      }
      return flag;
    },
    isEditName(row) { // 是否可以编辑名称
      console.log("--- row:---", row)
      
      console.log();
      
      if (this.isCopy || this.isDraftEdit) { // 复制模式和草稿编辑可以编辑名称
        return true
      }
      // 活动未开始且不是查看模式
      if (!this.activityData.isStart && !this.backgroundOpacity) {
        return true
      }
      let flag = true;
      if (row.id) {
        flag = false;
      }
      return flag;
    },
    isEditCount(row) { // 是否可以编辑数量
      if (this.isCopy || this.isDraftEdit) { // 复制模式和草稿编辑可以编辑名称
        return true
      }
      // 活动未开始且不是查看模式
      if (!this.activityData.isStart && !this.backgroundOpacity) {
        return true
      }
      let flag = true;
      if (row.id) {
        flag = false;
      }
      return flag;
    },
  }
}
</script>

<style scoped lang="scss">
.setting-level {
  display: flex;
  align-items: center;

  &-item {
    cursor: pointer;
    padding: 5px 14px;
    font-size: 14px;
    color: #999999;
    text-align: center;
    background: #f8f9fc;
    margin-right: 4px;
    border-bottom: 4px solid #ffffff;
    border-radius: 4px 4px 0 0;

    &__active {
      color: #2768ff;
      border-bottom: 4px solid #f8f9fc;
    }
  }
}

.rule-set-box {
  background: #f8f9fc;
  padding: 20px 20px 20px 0;
  border-radius: 4px;
}

.mr-r-6 {
  margin-right: 6px;
}

.linkTip {
  display: inline-block;
  color: #f56c6c;
  line-height: 22px;
}

.s {
  color: #2768ff;
  cursor: pointer;
  font-size: 14px;
}
</style>